import React, { useState, useEffect } from 'react'

// import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import Stepflow from './stepflow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { BsSendCheckFill } from "react-icons/bs";
import { HiClipboardDocumentList } from "react-icons/hi2";
import RateReviewIcon from '@mui/icons-material/RateReview';
import PopUpRecall from '../newDocument/popupcomponent/PopUpRecall';
import Box from '@mui/material/Box';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import ThumbDownAltRoundedIcon from '@mui/icons-material/ThumbDownAltRounded';
import { useDemoData } from '@mui/x-data-grid-generator';
import { GridToolbar } from '@mui/x-data-grid';
import AppDataGrid from '../../../../components/datatable/AppDataGrid';
import FetchApi from '../../../customhooks/Functionapi';
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import PopUpViewFlowstatus from '../viewflowprocess/PopUpViewFlowstatus';
import { GridActions, ActionButton, ActionPopup, StatusChip } from '../../../../components/datatable/GridActions';

const renderActions = (row) => {
    const canView = row.statusActions == '104' || row.statusActions == '111';
    const canRevise = row.statusActions == '111' || (row.statusActions == '104' && row.statusName == 'Successful');

    return (
        <GridActions>
            {canView &&
                <ActionButton to={`/docmentViewAll/${row.JournalID}`} title="View" tone="view">
                    <VisibilityIcon />
                </ActionButton>}

            {row.statusActions == '103' &&
                <ActionButton to={`/editdocument/${row.JournalID}`} title="Edit" tone="edit">
                    <ModeEditIcon />
                </ActionButton>}

            {row.statusActions == '201' &&
                <ActionButton to={`/rejectdocuments/${row.JournalID}/201`} title="Edit" tone="edit">
                    <ModeEditIcon />
                </ActionButton>}

            {row.statusActions == '103' &&
                <ActionButton to={`/sendStatus/${row.JournalID}`} title="Send" tone="send">
                    <BsSendCheckFill />
                </ActionButton>}

            {canRevise &&
                <ActionButton to={`/revisedocuments/${row.JournalID}`} title="Revise" tone="revise">
                    <HiClipboardDocumentList />
                </ActionButton>}

            <ActionPopup tone="flow">
                <PopUpViewFlowstatus jourId={row.JournalID} />
            </ActionPopup>
        </GridActions>
    )
}

const renderCard = (row) => (
    <Card variant="outlined" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <CardContent style={{ paddingBottom: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ fontWeight: 'bold', fontSize: 16 }}>{row.JournalCode}</span>
                <StatusChip label={row.statusName} />
            </div>
            <div style={{ fontSize: 15, marginBottom: 8 }}>{row.ItemName}</div>
            <div style={{ fontSize: 13, color: '#6b6b6b', lineHeight: 1.6 }}>
                <div>ItemID: {row.ItemID}</div>
                <div>ItemTypeID: {row.ItemTypeID}</div>
                <div>CustID: {row.CustID}</div>
                <div>TransDate: {row.TransDate}</div>
            </div>
            <div style={{ marginTop: 10 }}>
                <Stepflow
                    stateflow={row.stateflow}
                    endstateflow={row.frstateflow}
                    statusflow={row.statusflow}
                    activerecieved={row.activerecieved}
                    activeapproved={row.activeapproved}
                />
            </div>
        </CardContent>
        <CardActions style={{ borderTop: '1px solid #eee' }}>
            {renderActions(row)}
        </CardActions>
    </Card>
)

const columns = [
    // { field: 'num', headerName: 'NO', width: 50 },
    {
        field: 'JournalCode',
        headerName: 'Journal Code',
        width: 150,
        // editable: true,
    },
    {
        field: 'TransDate',
        headerName: 'TransDate',
        width: 120,
        // editable: true,
    },
    {
        field: 'ItemTypeID',
        headerName: 'ItemTypeID',
        // type: 'number',
        width: 150,
        // editable: true,
    },
    {
        field: 'CustID',
        headerName: 'CustID',
        // type: 'number',
        width: 100,
        // editable: true,
    },
    {
        field: 'ItemID',
        headerName: 'ItemID',
        // type: 'number',
        width: 110,
        // editable: true,
    },
    {
        field: 'ItemName',
        headerName: 'ItemName',
        // type: 'number',
        width: 250,
        // editable: true,
    },
    {
        field: 'statusName',
        headerName: 'status',
        // type: 'number',
        width: 100,
               renderCell: (params) => <StatusChip label={params.row.statusName} />
        // editable: true,
    },
    {
        field: 'Processflow',
        headerName: 'Process flow',
        sortable: false,
        width: 200,
        renderCell: (params) => {
            return (
                <div style={{ flexDirection: 'row', alignContent: 'flex-start', display: 'flex' }}>

                    <Stepflow
                        stateflow={params.row.stateflow}
                        endstateflow={params.row.frstateflow}
                        statusflow={params.row.statusflow}
                        activerecieved={params.row.activerecieved}
                        activeapproved={params.row.activeapproved}

                    />
                </div>
            )
        }

    },
    {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 180,
        minWidth: 180,
        cellClassName: 'actions',
        align: 'left',
        headerAlign: 'left',
        sortable: false,
        resizable: false,
        renderCell: (params) => renderActions(params.row)

    }
];

// ปุ่ม filter สถานะเอกสาร (ไฮไลต์ตัวที่เลือก + จำนวนเอกสารในปุ่ม)
function FilterChip({ label, Icon, color, count, active, onClick }) {
    return (
        <Box
            component="button"
            type="button"
            onClick={onClick}
            sx={{
                display: 'inline-flex', alignItems: 'center', gap: 0.75,
                height: 36, px: 1.5, borderRadius: 999, cursor: 'pointer',
                fontFamily: 'inherit', fontSize: 13.5, fontWeight: 600, letterSpacing: 0.2,
                border: '1px solid', borderColor: active ? color : 'transparent',
                bgcolor: active ? color : 'transparent',
                color: active ? '#fff' : color,
                boxShadow: active ? `0 4px 12px ${color}40` : 'none',
                transition: 'all .18s',
                '&:hover': { bgcolor: active ? color : `${color}14` },
                '&:focus-visible': { outline: `2px solid ${color}`, outlineOffset: 2 },
            }}
        >
            <Icon sx={{ fontSize: 18 }} />
            {label}
            {count !== undefined && (
                <Box component="span" sx={{
                    minWidth: 22, height: 20, px: 0.75, borderRadius: 999,
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 11.5, fontWeight: 700,
                    bgcolor: active ? 'rgba(255,255,255,0.25)' : `${color}1f`,
                    color: active ? '#fff' : color,
                }}>
                    {count > 99 ? '99+' : count}
                </Box>
            )}
        </Box>
    );
}

const Approvedlist = () => {

    const FetchApis = new FetchApi();
    const userId = sessionStorage.getItem('userId')
    const [journalList, setJournalList] = useState([])
    const [dataAll, setDataAll] = useState([])

    const [countReject, setCountReject] = useState(0)

    const [countRejectEdit, setCountRejectEid] = useState(0)

    const [countapproved, setCountApproved] = useState(0)
    const [countdraft, setCountDraft] = useState(0)
    const [countsuccessfully, setCountsuccessfully] = useState(0)
    const [activeFilter, setActiveFilter] = useState('all')

    const { data, loading } = useDemoData({
        dataSet: 'Commodity',
        rowLength: 10,
        maxColumns: 6,
    });

    useEffect(() => {

        journalAll()
        getstatusAll()


    }, [])

    function getRowId(row) {
        return row.JournalID;
    }


    const journalAll = () => {

        FetchApis.FethcGet(`/document/DocumentAllByUserId/${userId}`).then(res => {
            if (res.status == 200) {
                // เมนู All ไม่แสดงเอกสารที่เสร็จแล้ว (statusflow 105 = Successful) ดูได้ที่เมนู Successfully
                const notFinished = res.data.filter(row => String(row.statusflow) !== '105');
                setJournalList(notFinished);
                setDataAll(notFinished);
            }
        })

    }
    const journalDraftAll = () => {

        FetchApis.FethcGet(`/document/DocumentDraftByUserId/${userId}`).then(res => {
            if (res.status == 200) {
                setJournalList(res.data);
                setDataAll(res.data);
            }

        })

    }

    // const journalInpreview = () => {

    //     FetchApis.FethcGet(`/document/DocumentInpreview/${userId}`).then(res => {
    //         if (res.status == 200) {
    //             setJournalList(res.data);
    //         }

    //     })
    // }

    // const journalpanding = () => {
    //     FetchApis.FethcGet(`/document/DocumentPreRecieved/${userId}`).then(res => {
    //         if (res.status == 200) {
    //             setJournalList(res.data);

    //         }

    //     })

    // }

    // ค้นหาจาก transition table
    const journalApproved = () => {
        FetchApis.FethcGet(`/document/DocumentApprovedlist/${userId}`).then(res => {

            if (res.status == 200) {
                setJournalList(res.data);
                console.log(res.data)
            }

        })
    }

    // ค้นหาจาก transition table
    const journalReject = () => {

        FetchApis.FethcGet(`/document/DocumentRejectlist/${userId}`).then(res => {
            if (res.status == 200) {

                setJournalList(res.data);

            }

        })


    }

    // const journalRejectSuccess = () => {

    //     FetchApis.FethcGet(`/document/DocumentRejectlistsuccessful/${userId}`).then(res => {

    //         if (res.status == 200) {
    //             setJournalList(res.data);

    //         }

    //     })


    // }

    const journalSuccessfully = async () => {
        await FetchApis.FethcGet(`/document/DocumentSuccessfullylist/${userId}`).then(res => {
            if (res.status == 200) {

                setJournalList(res.data);

            }

        })
    }

    async function getstatusAll() {

        await FetchApis.FethcGet(`/document/DocumentDraftByUserId/${userId}`).then(res => { // approved แล้ว

            if (res.status == 200) {
                setCountDraft(res.data.length)
                console.log(res.data.length)
            }

        })

        await FetchApis.FethcGet(`/document/DocumentApprovedlist/${userId}`).then(res => { // approved แล้ว

            if (res.status == 200) {
                setCountApproved(res.data.length)
            }

        })

        await FetchApis.FethcGet(`/document/DocumentRejectlist/${userId}`).then(res => { // รายการที่ reject กลับมา

            if (res.status == 200) {
                setCountReject(res.data.length)
            }

        })

        await FetchApis.FethcGet(`/document/DocumentRejectlistsuccessful/${userId}`).then(res => {
            if (res.status == 200) {
                setCountRejectEid(res.data.length);

            }

        })

        //  const journalSuccessfully = async () => {
        await FetchApis.FethcGet(`/document/DocumentSuccessfullylist/${userId}`).then(res => {
            if (res.status == 200) {
                setCountsuccessfully(res.data.length);

            }

        })
        // }
    }

    const filterBySearch = (event) => {

        const query = event.target.value;

        const filteredData = dataAll.filter(item => {
            return Object.values(item)
                .join('')
                .toLowerCase()
                .includes(query.toLowerCase());
        });

        setJournalList(filteredData);
    };


    return (
        <div>
            <div style={{ width: '100%', marginTop: 50 }}>

                <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', padding: 10 }}>

                    <div style={{ marginLeft: '2%', display: 'flex' }}>
                        <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                        >
                            <IconButton sx={{ p: '10px' }} aria-label="menu">
                                <MenuIcon />
                            </IconButton>
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Search Journal by Id"
                                inputProps={{ 'aria-label': 'search document' }}
                                onChange={(e) => filterBySearch(e)}

                            />
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        </Paper>
                    </div>

                    <Box sx={{ mr: '5%', display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                        <Box sx={{
                            display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap',
                            p: 0.75, bgcolor: '#fff', border: '1px solid #e3e6ea', borderRadius: 999,
                            boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06)',
                        }}>
                            <FilterChip label="All" Icon={AppsRoundedIcon} color="#37474f"
                                active={activeFilter === 'all'} onClick={() => { setActiveFilter('all'); journalAll() }} />
                            <FilterChip label="Draft" Icon={EditNoteRoundedIcon} color="#78909c" count={countdraft}
                                active={activeFilter === 'draft'} onClick={() => { setActiveFilter('draft'); journalDraftAll() }} />
                            <FilterChip label="Approved" Icon={TaskAltRoundedIcon} color="#2e7d32" count={countapproved}
                                active={activeFilter === 'approved'} onClick={() => { setActiveFilter('approved'); journalApproved() }} />
                            <FilterChip label="Successfully" Icon={VerifiedRoundedIcon} color="#1e88e5" count={countsuccessfully}
                                active={activeFilter === 'successfully'} onClick={() => { setActiveFilter('successfully'); journalSuccessfully() }} />
                            <FilterChip label="Reject" Icon={ThumbDownAltRoundedIcon} color="#e53935" count={countReject}
                                active={activeFilter === 'reject'} onClick={() => { setActiveFilter('reject'); journalReject() }} />
                        </Box>
                        <PopUpRecall userId={userId} />
                    </Box>

                </div>
                <label style={{ fontSize: 18, color: '#807c7c', padding: '0 10px' }}>Total list  ( {journalList.length} ) </label>

                <div style={{ height: 'auto', width: '100%', padding: '0 10px', boxSizing: 'border-box' }}>
                    <AppDataGrid
                        rows={journalList}
                        getRowId={getRowId}
                        columns={columns}
                        loading={loading}
                        viewStorageKey="documentsViewMode"
                        renderCard={renderCard}
                        slots={{ toolbar: GridToolbar }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50, 100]}
                    />
                </div>
            </div>
        </div>
    )
}

export default Approvedlist